<template>
	<div id="app">
		<router-view></router-view>
		<!-- <p class="footMes">Copyright  2019  由五棵松文体信息技术中心提供技术支持    联系电话：010-68291101</p> -->
	</div>
</template>

<script>
	export default {
		name: 'App',
		data() {
			return {
				froalaConfig: {
					toolbarButtons: ['undo', 'redo', 'clearFormatting', '|', 'bold', 'italic', 'underline', 'strikeThrough', '|',
						'fontFamily', 'fontSize', 'color', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent',
						'quote', '-', 'insertLink', 'insertImage', 'insertVideo', 'embedly', 'insertFile', 'insertTable', '|',
						'emoticons', 'specialCharacters', 'insertHR', 'selectAll', '|', 'print', 'spellChecker', 'help', '|',
						'fullscreen'
					], //['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertVideo', 'embedly', 'insertFile', 'insertTable', '|', 'emoticons', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'spellChecker', 'help', 'html', '|', 'undo', 'redo'],//显示可操作项
					// theme: "dark",//主题
					placeholder: "请填写内容",
					language: "zh_cn", //国际化
					imageUploadURL: "http://i.froala.com/upload", //上传url
					fileUploadURL: "http://i.froala.com/upload", //上传url 更多上传介绍 请访问https://www.froala.com/wysiwyg-editor/docs/options
					quickInsertButtons: ['image', 'table', 'ul', 'ol', 'hr'], //快速插入项
					// toolbarVisibleWithoutSelection: true,//是否开启 不选中模式
					// disableRightClick: true,//是否屏蔽右击
					colorsHEXInput: false, //关闭16进制色值
					toolbarSticky: true, //操作栏是否自动吸顶
					zIndex: 99999,
					events: {
						'froalaEditor.initialized': function() {
							console.log('initialized')
						}
					},
				},
				froalaContent: "<p>www</p>", //默认测试文本 

			}
		},
		components: {

		}
	}
</script>

<style>
	@import url("//at.alicdn.com/t/font_1123180_uk6kojzc5q.css");

	* {
		margin: 0px;
		padding: 0px;
	}

	html,
	body {
		width: 100%;
		height: 100%;
	}

	#app {
		width: 100%;
		height: 100%;
	}

	body>.el-container {
		height: 100%;
		margin-bottom: 40px;
	}

	.el-main {
		background-color: #585F66;
		color: #333;
	}

	.el-header {
		background-color: #545c64;
		color: #fff;
	}

	.mainBox {
		width: 100%;
		height: 100%;
		background: #fff;
		border-radius: 10px;
	}
	
/* 	.footMes{
		font-size: 12px;
		width: 100%;
		position: fixed;
		bottom: 10px;
		text-align: center;
	} */
</style>



// WEBPACK FOOTER //
// src/App.vue